module.exports = __webpack_public_path__ + "images/complex_example.png";